import type { RouteObject } from "react-router-dom"
import { useRoutes } from "react-router-dom"
import { lazy, Suspense } from "react"
import Home from "@/pages/Home"

const LifelineBling = lazy(() => import("@/pages/LifelineBling"))
const FortniteBling = lazy(() => import("@/pages/FortniteBling"))
const ValorantBling = lazy(() => import("@/pages/ValorantBling"))
const Blog = lazy(() => import("@/pages/Blog"))
const About = lazy(() => import("@/pages/About"))
const Admin = lazy(() => import("@/pages/Admin"))

const LazyFallback = (
  <div className="min-h-screen bg-[#0A0A0F] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-yellow-500/30 border-t-yellow-500 rounded-full animate-spin" />
  </div>
)

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  {
    path: "/lifeline-bling",
    element: (
      <Suspense fallback={LazyFallback}>
        <LifelineBling />
      </Suspense>
    ),
  },
  {
    path: "/fortnite-bling",
    element: (
      <Suspense fallback={LazyFallback}>
        <FortniteBling />
      </Suspense>
    ),
  },
  {
    path: "/valorant-bling",
    element: (
      <Suspense fallback={LazyFallback}>
        <ValorantBling />
      </Suspense>
    ),
  },
  {
    path: "/blog",
    element: (
      <Suspense fallback={LazyFallback}>
        <Blog />
      </Suspense>
    ),
  },
  {
    path: "/about",
    element: (
      <Suspense fallback={LazyFallback}>
        <About />
      </Suspense>
    ),
  },
  {
    path: "/admin",
    element: (
      <Suspense fallback={LazyFallback}>
        <Admin />
      </Suspense>
    ),
  },
]

function App() {
  return useRoutes(routes)
}

export default App
